// React things
import { useEffect } from 'react'
import { Routes, Route, useLocation, Navigate } from 'react-router-dom'

// Styles
import style from './Router.module.css'

// Stores
import useApplicationSettings from '../Store/ApplicationSettings.js'

// Services
import { analytics } from '../Services/Analytics'

// Components
import Mining from '../Pages/Mining.jsx'

// import Tasks from '../Pages/Tasks.jsx'
import Shop from '../Pages/Shop/Shop.jsx'

import Referrer from '../Pages/Referrer.jsx'
import Profile from '../Pages/Profile/Profile.jsx'
import LeaderBoard from '../Pages/Profile/LeaderBoard/LeaderBoard.jsx'
import Vouchers from '../Pages/Vouchers/Vouchers.jsx'
import FortuneWheel from '../Pages/DailyQuests/FortuneWheel.jsx'

import QuestPage from '../Pages/Tasks_new/QuestPage.tsx'
import Earn from '../Pages/Earn/Earn.tsx'
import TasksPage from '../Pages/Tasks_new/TasksPage.tsx'
import CreateContentPage from '../Pages/CreateContent/CreateContentPage'
import GiveawayList from '../Pages/Giveaway/Components/GiveawayList/GiveawayList'
import GiveawayDetails from '../Pages/Giveaway/Components/GiveawayDetails/GiveawayDetails'
import { ExpeditionDetails } from '../Pages/Expeditions/components/ExpeditionDetails/ExpeditionDetails'

export default function Router(props) {
	const setMenubarTrigger = useApplicationSettings(state => state.setMenubarTrigger)
	const location = useLocation()
	const tg = window.Telegram.WebApp

	useEffect(() => {
		// Инициализация аналитики при монтировании
		analytics.init()

		return () => {
			// Очистка при размонтировании
			analytics.destroy()
		}
	}, [])

	useEffect(() => {
		const path = location.pathname
		console.log('path', path)

		// Отслеживаем переход на новую страницу
		analytics.trackEvent('page_view', path, {
			userId: tg.initDataUnsafe?.user?.id,
		})

		switch (path) {
			case '/referrer':
				setMenubarTrigger({ triggerName: 'Referals' })
				break
			case '/profile':
				setMenubarTrigger({ triggerName: 'Profile' })
				break
			case '/':
				setMenubarTrigger({ triggerName: 'Mining' })
				break
			case '/shop':
				setMenubarTrigger({ triggerName: 'Shop' })
				break
			case '/fortune-wheel':
				setMenubarTrigger({ triggerName: 'FortuneWheel' })
				break
			case '/vouchers':
				setMenubarTrigger({ triggerName: 'Vouchers' })
				break
			case '/earn':
				setMenubarTrigger({ triggerName: 'Earn' })
				break
			case '/tasks/:type':
				setMenubarTrigger({ triggerName: 'Tasks_new' })
				break
			case '/quests/:slug':
				setMenubarTrigger({ triggerName: 'QuestTasks' })
				break
			case '/create-content':
				setMenubarTrigger({ triggerName: 'CreateContent' })
				break
			case '/giveaway':
				setMenubarTrigger({ triggerName: 'Giveaway' })
				break
			case '/giveaway/:id':
				setMenubarTrigger({ triggerName: 'GiveawayDetails' })
				break
		}
	}, [location.pathname, setMenubarTrigger])

	return (
		<div className={style['pages-container']}>
			<Routes>
				<Route exact path='/' element={<Mining />} />
				<Route path='referrer' element={<Referrer />} />
				<Route path='profile' element={<Profile />} />
				<Route path='leaderboard' element={<LeaderBoard />} />
				<Route path='vouchers' element={<Vouchers />} />
				<Route path='shop' element={<Shop />} />

				<Route path='fortune-wheel' element={<FortuneWheel />} />
				<Route path='earn' element={<Earn />} />
				<Route path='tasks/:type' element={<TasksPage />} />
				<Route path='quests/:slug' element={<QuestPage />} />
				<Route path='create-content' element={<CreateContentPage />} />
				<Route path='giveaway' element={<GiveawayList />} />
				<Route path='giveaway/:id' element={<GiveawayDetails />} />
				<Route path='expedition/:id' element={<ExpeditionDetails />} />

				<Route path='*' element={<Navigate to='/' replace />} />
			</Routes>
		</div>
	)
}
